import { REDUCERS } from '@/constants/reducers';

export const apuestasDeportivasFeed = (state, action) => {
    switch (action.type) {
        case REDUCERS.UPDATE_APUESTAS_DEPORTIVAS_FEED:
            return {
                ...state,
                apuestasDeportivasFeed: action.payload,
            };
        default:
            return state;
    }
};
